export default "__VITE_ASSET__A6yXhxFX__"